var map = {
	"./Equipamentos.jpg": "80db",
	"./all-in-one.jpg": "c2e1",
	"./care.jpg": "1a89",
	"./celeron.jpg": "290c",
	"./controlId.jpg": "e658",
	"./fusion-all-in-one.jpg": "765f",
	"./intel-celeron.jpg": "27e5",
	"./m10.jpg": "14f5",
	"./monitor-touch.jpg": "578a",
	"./printId.jpg": "2060",
	"./stone.png": "4ab8",
	"./tablet.jpg": "697f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0cf0";